import { Button, Checkbox, Col, Form, Modal, Row, Select, Tabs, Tooltip } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { CheckCircle, ChevronDown, ChevronUp, CloseIcon, Information } from '../../assets/icons';
import FloatingLabel from '../../components/FloatingLabel/FloatingLabel';
import BankAccountModal from '../../components/LinkBankAccount/BankAccountModal';
import ListingAgreement from '../../components/ListingAgreement/ListingAgreement';
import PinModalWithoutButton from '../../components/PinModalWithoutButton/PinModalWithoutButton';
import BuyOrder from '../../components/SecondaryTrade/BuyOrder';
import SellOrder from '../../components/SecondaryTrade/SellOrder';
import SuccessModal from '../../components/SuccessModal/SuccessModal';
import { Images } from '../../config/images';
import useMediaQuery from '../../Hooks/useMediaQuery';
import { formatePhoneNumber } from '../../utils/formatPhoneNumber';
import { getBankLogo } from '../../utils/getBankLogo';
import { getUsCurrencyFormat } from '../../utils/usCurrencyFormatter';
import ResetPin from '../Account/Profile/Modals/ResetPin';
import { BuyReviewData, BuySuccessData, SellReviewData, SellSuccessData } from './TradeData';

const TradeModal = (props) => {
  const { quickBuyPropertyData, isSingleTab, isSell, featchData, quickBuySecondaryOptions } = props;
  const [isScrolledBuy] = useState(false);
  const [shareValue, setShareValue] = useState();
  const [sellPrice, setSellPrice] = useState();
  const [, setReviewData] = useState(BuyReviewData);
  const [successData, setSuccessData] = useState(BuySuccessData);
  const [bankModalOpen, setBankModalOpen] = useState(false);
  const [bankOpen, setBankOpen] = useState(false);
  const loading = useSelector((state) => state.secondaryPlaceBid.loading);
  const orderRef = useRef();
  const userProfileData = useSelector((state) => state.userData.userData);
  const phoneNumber = ['+1', formatePhoneNumber(userProfileData?.phoneNumber)];
  const linkText = 'My Account>Account Balances';
  const linkPath = '/account/transactions';
  const openLink = () => {
    window.location.href = linkPath;
  };
  const {
    pin,
    resetPin,
    loading: hookLoading,
    numberOfShare,
    isMaxRangeError,
    isMinRangeError,
    minButtonValue,
    sharesRemainingToPurchase,
    limitPrice,
    LowestAskPrice,
    duration,
    totalInvestment,
    transactionFee,
    totalPurchase,
    isEditPayment,
    walletsData,
    selectedPaymentMethod,
    isTurmAndCondistion,
    partialFills,
    perSharePrice,
    userPurchasedShare,
    activeTab,
    setActiveTab,
    setPartialFills,
    setPin,
    handleVerifyPin,
    handleForgotPin,
    setResetPin,
    setNumberOfShare,
    setLimitPrice,
    setDuration,
    setIsEditPayment,
    handleSelectPaymentMethod,
    handleAddBank,
    setIsTurmAndCondistion,
    handlePlaceBid,
    handleSellOrder,
    setLoading,
    isTOSModal,
    onTOSAgreementSuccess,
    onTOSModalClose,
  } = quickBuySecondaryOptions;

  function handleSellClick() {
    setReviewData(SellReviewData);
    setSuccessData(SellSuccessData);
    props.modalState('StepThree');
  }

  useEffect(() => {
    setActiveTab(isSell);
  }, [isSell]);
  const screenMD = useMediaQuery('(min-width: 1000px)');
  return (
    <>
      {/* === vPIN Modal Starts Here === */}
      {screenMD && (
        <>
          {props.open === 'StepOne' && (
            <PinModalWithoutButton
              onCancel={() => {
                props.modalState();
                setPin('');
              }}
              open={props.open === 'StepOne'}
              pin={pin}
              loading={hookLoading}
              handleForgotPin={handleForgotPin}
              setPin={setPin}
              setLoading={setLoading}
              onSuccess={(isTOSAccepted) => {
                orderRef?.current?.resetFields();
                handleVerifyPin(isTOSAccepted);
              }}
            />
          )}
        </>
      )}

      {/* === PIN Modal Ends Here === */}

      {/* === Buy / Sell Order Modal Starts Here === */}
      <ResetPin phoneNumber={phoneNumber} mail={userProfileData?.email} setOpen={resetPin} setClose={() => setResetPin(false)} />
      <BankAccountModal
        bankModalOpen={bankModalOpen}
        setBankModalOpen={(value) => setBankModalOpen(value)}
        onSuccess={(value) => handleAddBank(value)}
        onClose={() => setIsEditPayment(false)}
      />
      {screenMD && (
        <>
          {props.open === 'StepTwo' && (
            <Modal
              className='quickbuy buy-order ant-modal--footer-shadow ant-modal--both'
              open={props.open === 'StepTwo'}
              // onCancel={() => props.modalState()}
              title={
                <div className={isScrolledBuy ? 'buy-order-header scrolled' : 'buy-order-header'}>
                  <div className='header__img'>
                    {quickBuyPropertyData?.images?.image1 ? (
                      <LazyLoadImage
                        onError={(element) => {
                          element.target.src = Images.noPropertyFoundImage;
                        }}
                        src={quickBuyPropertyData?.images?.image1}
                        alt='house with garden'
                      />
                    ) : (
                      <LazyLoadImage src={Images.noPropertyFoundImage} alt='the-leonardo' />
                    )}
                  </div>
                  <div className='header__content'>
                    <p className='subhead-2 text-copper mb-0'>{quickBuyPropertyData?.propertyName || ''}</p>
                    <div className='name-type'>
                      <span className='fz-12'>{`${quickBuyPropertyData?.cityName || ''}, ${quickBuyPropertyData?.stateName || ''}`}</span>
                      <span className='fz-12 ml-4 mr-4 text-taupe-60'>•</span>
                      <span className='fz-12'>{quickBuyPropertyData?.propertyType || ''}</span>
                    </div>
                    <div className='share-details mt-12'>
                      <div className='block'>
                        <span className='text-taupe-80'>Last price</span>
                        <span className='subhead-3'>{`$${getUsCurrencyFormat(quickBuyPropertyData?.lastTradedPrice || 0)}`}</span>
                      </div>
                      <div className='block'>
                        <span className='text-taupe-80'>All time</span>
                        <span className='subhead-3'>
                          {`${getUsCurrencyFormat(quickBuyPropertyData?.allTime) > 0 ? '+' : ''} ${getUsCurrencyFormat(
                            (quickBuyPropertyData?.allTime || '').toString().replace(',', '') || 0
                          )}%`}
                        </span>
                      </div>
                      <div className='block'>
                        <span className='text-taupe-80'>
                          Div yield
                          <Tooltip
                            placement='bottom'
                            popupClassName='div-yeild-pop'
                            title='The dividend percentage is the most recent profit-sharing amount paid by Realbricks to this property’s investors. It is paid, and varies, on a quarterly basis. The dividend percentage is calculated by dividing the total dividend payment (to be split amongst share owners) by the total property purchase price (raised during the initial offering period). The dividend payment you receive will be proportional to your ownership of the property.'
                          >
                            <span>
                              <Information className='cursor-pointer' verticalAlign='middle' marginLeft='4px' color='#1A1519' />
                            </span>
                          </Tooltip>
                        </span>
                        <span className='subhead-3'>{`${getUsCurrencyFormat(quickBuyPropertyData?.dividendYield || 0)} %`}</span>
                      </div>
                    </div>
                  </div>
                </div>
              }
              footer={
                <>
                  {activeTab === '1' && (
                    <Button
                      type='primary'
                      className='w-100 mt-8 mb-8'
                      onClick={() => props.modalState('StepThree')}
                      disabled={
                        !numberOfShare ||
                        !duration ||
                        isMaxRangeError ||
                        Number(numberOfShare) % 1 !== 0 ||
                        !/^(?!0\d)(\d+(?:\.\d{1,2})?)$/.test(limitPrice)
                      }
                    >
                      Preview order
                    </Button>
                  )}
                  {activeTab === '2' && (
                    <Button
                      disabled={
                        !numberOfShare ||
                        !duration ||
                        numberOfShare > userPurchasedShare ||
                        Number(numberOfShare) % 1 !== 0 ||
                        !/^(?!0\d)(\d+(?:\.\d{1,2})?)$/.test(limitPrice) ||
                        totalPurchase <= 0
                      }
                      type='primary'
                      className='w-100 mt-8 mb-8'
                      onClick={handleSellClick}
                    >
                      Preview order
                    </Button>
                  )}
                </>
              }
              width={524}
              closeIcon={<CloseIcon onClick={() => props.modalState()} />}
              centered
            >
              {isSingleTab ? (
                <BuyOrder
                  ref={orderRef}
                  numberOfShare={numberOfShare}
                  isMaxRangeError={isMaxRangeError}
                  isMinRangeError={isMinRangeError}
                  minButtonValue={minButtonValue}
                  sharesRemainingToPurchase={sharesRemainingToPurchase}
                  setNumberOfShare={setNumberOfShare}
                  limitPrice={limitPrice}
                  setLimitPrice={setLimitPrice}
                  LowestAskPrice={LowestAskPrice}
                  duration={duration}
                  quickBuyPropertyData={quickBuyPropertyData}
                  setDuration={setDuration}
                  totalInvestment={totalInvestment}
                  transactionFee={transactionFee}
                  totalPurchase={getUsCurrencyFormat(totalPurchase)}
                  partialFills={partialFills}
                  setPartialFills={setPartialFills}
                />
              ) : (
                <Tabs
                  className='mt-24'
                  defaultActiveKey={activeTab}
                  value={activeTab}
                  onChange={(key) => {
                    setActiveTab(key);
                    if (key === '2') {
                      setNumberOfShare('');
                      setLimitPrice('');
                      setDuration('');
                      orderRef.current.resetFields();
                    } else {
                      setNumberOfShare('');
                      setLimitPrice('');
                      setDuration('');
                      orderRef.current.resetFields();
                    }
                  }}
                  items={[
                    {
                      label: 'Buy',
                      key: '1',
                      children: (
                        <BuyOrder
                          ref={orderRef}
                          numberOfShare={numberOfShare}
                          isMaxRangeError={isMaxRangeError}
                          isMinRangeError={isMinRangeError}
                          minButtonValue={minButtonValue}
                          sharesRemainingToPurchase={sharesRemainingToPurchase}
                          setNumberOfShare={setNumberOfShare}
                          limitPrice={limitPrice}
                          setLimitPrice={setLimitPrice}
                          LowestAskPrice={LowestAskPrice}
                          duration={duration}
                          quickBuyPropertyData={quickBuyPropertyData}
                          setDuration={setDuration}
                          totalInvestment={totalInvestment}
                          transactionFee={transactionFee}
                          totalPurchase={getUsCurrencyFormat(totalPurchase)}
                          partialFills={partialFills}
                          setPartialFills={setPartialFills}
                        />
                      ),
                    },
                    {
                      label: 'Sell',
                      key: '2',
                      children: (
                        <>
                          <SellOrder
                            ref={orderRef}
                            shareValue={shareValue}
                            setShareValue={setShareValue}
                            sellPrice={sellPrice}
                            setSellPrice={setSellPrice}
                            duration={duration}
                            setDuration={setDuration}
                            userPurchasedShare={userPurchasedShare}
                            numberOfShare={numberOfShare}
                            setNumberOfShare={setNumberOfShare}
                            limitPrice={limitPrice}
                            setLimitPrice={setLimitPrice}
                            LowestAskPrice={LowestAskPrice}
                            quickBuyPropertyData={quickBuyPropertyData}
                            totalInvestment={totalInvestment}
                            transactionFee={transactionFee}
                            totalPurchase={getUsCurrencyFormat(totalPurchase)}
                            partialFills={partialFills}
                            setPartialFills={setPartialFills}
                          />
                        </>
                      ),
                    },
                  ]}
                />
              )}
            </Modal>
          )}
        </>
      )}

      {/* === Buy / Sell Order Modal Ends Here === */}

      {/* === Order Review Modal Starts Here ===  */}
      {screenMD && (
        <Modal
          className='quickbuy review-buy-order ant-modal--footer-shadow ant-modal--footer'
          open={props.open === 'StepThree'}
          // onCancel={() => props.modalState()}
          width={524}
          closeIcon={<CloseIcon onClick={() => props.modalState()} />}
          footer={
            <>
              <Row gutter={16} className='mt-8 mb-8'>
                <Col span={12}>
                  <Button className='w-100' onClick={() => props.modalState('StepTwo')}>
                    Back
                  </Button>
                </Col>
                <Col span={12}>
                  <Button
                    loading={loading}
                    disabled={!isTurmAndCondistion}
                    type='primary'
                    className='w-100'
                    onClick={() => (activeTab === '1' ? handlePlaceBid() : handleSellOrder())}
                  >
                    Place order
                  </Button>
                </Col>
              </Row>
            </>
          }
          centered
        >
          {isSell === '1' ? (
            <>
              <h4 className='text-center mb-24'>Review bid</h4>
              <p className='fw-600'>Investment details</p>
              <div className='d-flex flex-column g-16 fz-14'>
                <div className='d-flex align-items-center justify-content-space-between'>
                  <span className='text-taupe-80'>Shares</span>
                  <span>{numberOfShare || ''}</span>
                </div>
                <div className=' d-flex align-items-center justify-content-space-between'>
                  <span className='text-taupe-80'>Price per share</span>
                  <span>{`$${getUsCurrencyFormat(limitPrice || '')}`}</span>
                </div>
                <div className=' d-flex align-items-center justify-content-space-between'>
                  <span className='text-taupe-80'>Total investment</span>
                  <span>{`$${getUsCurrencyFormat(totalInvestment || '')}`}</span>
                </div>
                <div className=' d-flex align-items-center justify-content-space-between'>
                  <span className='text-taupe-80'>Platform fee </span>
                  <span>{`$2.50`}</span>
                </div>
                <div className=' d-flex align-items-center justify-content-space-between'>
                  <span className='text-taupe-80'>Broker-Dealer/ATS Fee (1%)</span>
                  <span>{`$${transactionFee || ''}`}</span>
                </div>
              </div>
              <hr className='mb-16 mt-16' />
              <div className='d-flex flex-column g-16 fz-14'>
                <div className='d-flex flex-column g-16 fz-14'>
                  <div className='d-flex align-items-center justify-content-space-between'>
                    <span className='text-taupe-80'>Total purchase (USD)</span>
                    <span className='fw-600'>{`$${getUsCurrencyFormat(totalPurchase || '')}`}</span>
                  </div>
                  <div className='d-flex align-items-center justify-content-space-between'>
                    <Tooltip
                      title={
                        <>
                          <p>
                            A “good until cancel” order is a buy or sell order that remains active until it is either executed or until the investor
                            cancels it.
                          </p>
                          <p className='mb-0'>
                            A “good for the day” order is a buy or sell order that is only good for the remainder of the trading day on which it is
                            placed. All “good for the day” orders will expire at 11:59 PM EST on the day they were placed.
                          </p>
                        </>
                      }
                    >
                      <span className='text-taupe-80 underline cursor-pointer'>Duration</span>
                    </Tooltip>
                    <span>{duration || ''}</span>
                  </div>
                </div>
              </div>
              {activeTab === '1' && (
                <>
                  <p className='fw-600 mt-32'>Payment details</p>
                  {!!isEditPayment ? (
                    <FloatingLabel label='Payment method' inputId='bankSelect' inputValue={selectedPaymentMethod.id}>
                      <div id='bank-anchor' />
                      <Form.Item className='mb-0' name='bankSelect'>
                        <Select
                          id='bankSelect'
                          onChange={(value) => {
                            value !== -1 ? handleSelectPaymentMethod(value) : setBankModalOpen(true);
                          }}
                          defaultValue={selectedPaymentMethod.id}
                          value={selectedPaymentMethod.id}
                          menuItemSelectedIcon={<CheckCircle verticalAlign='-8px' />}
                          getPopupContainer={() => document.getElementById('bank-anchor')}
                          onDropdownVisibleChange={() => setBankOpen(!bankOpen)}
                          suffixIcon={bankOpen ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
                        >
                          {walletsData?.map((item) => (
                            <Select.Option value={item.id}>
                              {getBankLogo(item?.brandName)} {item?.brandName === 'DWOLLA' ? 'Dwolla Wallet' : item?.brandName || ''}{' '}
                              {item?.sourceType !== 'Wallet' && item?.sourceType !== 'add new' && `*** ${item.lastFourDigit || ''}`}
                              {item?.sourceType === 'Wallet' && '$'}
                              {item?.sourceType === 'Wallet' ? (
                                totalInvestment > item?.balance ? (
                                  <span className='error-text'>Insufficient balance</span>
                                ) : (
                                  <span>{`${
                                    Number(item?.balance)
                                      .toFixed(2)
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',') || ''
                                  }`}</span>
                                )
                              ) : (
                                <span>{`${
                                  Number(item?.balance)
                                    .toFixed(2)
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',') || ''
                                }`}</span>
                              )}
                            </Select.Option>
                          ))}
                        </Select>
                        {selectedPaymentMethod?.sourceType === 'Wallet' && totalInvestment > selectedPaymentMethod?.balance && (
                          <div className='pt-10 error-text'>
                            <span style={{ cursor: 'pointer' }} onClick={openLink}>
                              Please go to {<a href={linkPath}>{linkText}</a>} to transfer funds into your account.
                            </span>
                          </div>
                        )}
                      </Form.Item>
                    </FloatingLabel>
                  ) : (
                    <>
                      <div className='d-flex g-8 align-items-center'>
                        {getBankLogo(selectedPaymentMethod?.brandName)}
                        <span className='fz-16'>
                          {selectedPaymentMethod?.brandName === 'DWOLLA' ? 'Dwolla Wallet' : selectedPaymentMethod?.brandName || ''}
                        </span>
                        {selectedPaymentMethod?.sourceType !== 'Wallet' && (
                          <span className='text-taupe-80 fz-16'>{`*** ${selectedPaymentMethod?.lastFourDigit || ''}`}</span>
                        )}
                        {selectedPaymentMethod?.sourceType === 'Wallet' &&
                        selectedPaymentMethod?.balance !== undefined &&
                        selectedPaymentMethod?.balance !== null ? (
                          totalInvestment > selectedPaymentMethod?.balance ? (
                            <span className='text-taupe-80 fz-16 error-text'>Insufficient balance</span>
                          ) : (
                            <span className='text-taupe-80 fz-16'>{`$${Number(selectedPaymentMethod?.balance)
                              .toFixed(2)
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}</span>
                          )
                        ) : null}
                      </div>
                      {selectedPaymentMethod?.sourceType === 'Wallet' && totalInvestment > selectedPaymentMethod?.balance && (
                        <div className='pt-10 error-text'>
                          <span style={{ cursor: 'pointer' }} onClick={openLink}>
                            Please go to {<a href={linkPath}>{linkText}</a>} to transfer funds into your account.
                          </span>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}

              <div className='d-flex mt-48'>
                <Checkbox checked={isTurmAndCondistion} onChange={(value) => setIsTurmAndCondistion(value.target.checked)} className='mr-16' />
                <span className='cursor-pointer fz-14'>
                  <span onClick={() => setIsTurmAndCondistion(!isTurmAndCondistion)}>I have read and accept the </span>
                  <Link to={{ pathname: '/legal', hash: 'Terms of use' }} className='underline' target='_blank'>
                    Terms of Use
                  </Link>
                  <span onClick={() => setIsTurmAndCondistion(!isTurmAndCondistion)}>, the </span>
                  <Link to={{ pathname: '/legal', hash: 'Other disclosure here' }} className='underline' target='_blank'>
                    Regulation A Investment Disclosure
                  </Link>
                  <span onClick={() => setIsTurmAndCondistion(!isTurmAndCondistion)}>, and </span>
                  <Link to={{ pathname: '/legal', hash: 'Privacy Policy' }} className='underline' target='_blank'>
                    Privacy Policy
                  </Link>
                  .
                </span>
              </div>
            </>
          ) : (
            <>
              <h4 className='text-center mb-24'>Review sell order</h4>
              <p className='fw-600'>Order details</p>
              <div className='d-flex flex-column g-16 fz-14'>
                <div className='d-flex align-items-center justify-content-space-between'>
                  <span className='text-taupe-80'>Shares</span>
                  <span>{numberOfShare || ''}</span>
                </div>
                <div className=' d-flex align-items-center justify-content-space-between'>
                  <span className='text-taupe-80'>Price per share</span>
                  <span>{`$${limitPrice || ''}`}</span>
                </div>
                <div className=' d-flex align-items-center justify-content-space-between'>
                  <span className='text-taupe-80'>Total investment</span>
                  <span>{`$${totalInvestment || ''}`}</span>
                </div>
                <div className=' d-flex align-items-center justify-content-space-between'>
                  <span className='text-taupe-80'>Platform fee </span>
                  <span>{`$2.50`}</span>
                </div>
                <div className=' d-flex align-items-center justify-content-space-between'>
                  <span className='text-taupe-80'>Broker-Dealer/ATS Fee (1%)</span>
                  <span>{`$${transactionFee || ''}`}</span>
                </div>
              </div>
              <hr className='mb-16 mt-16' />
              <div className='d-flex flex-column g-16 fz-14'>
                <div className='d-flex flex-column g-16 fz-14'>
                  <div className='d-flex align-items-center justify-content-space-between'>
                    <span className='text-taupe-80'>Net proceeds (USD)</span>
                    <span className='fw-600'>{`$${totalPurchase || ''}`}</span>
                  </div>
                  <div className='d-flex align-items-center justify-content-space-between'>
                    <Tooltip
                      title={
                        <>
                          <p>
                            A “good until cancel” order is a buy or sell order that remains active until it is either executed or until the investor
                            cancels it.
                          </p>
                          <p className='mb-0'>
                            A “good for the day” order is a buy or sell order that is only good for the remainder of the trading day on which it is
                            placed. All “good for the day” orders will expire at 11:59 PM EST on the day they were placed.
                          </p>
                        </>
                      }
                    >
                      <span className='text-taupe-80 underline cursor-pointer'>Duration</span>
                    </Tooltip>
                    <span>{duration || ''}</span>
                  </div>
                </div>
              </div>
              {activeTab === '1' && (
                <>
                  <p className='fw-600 mt-32'>Payment details</p>
                  {!!isEditPayment ? (
                    <FloatingLabel label='Payment method' inputId='bankSelect' inputValue={selectedPaymentMethod.id}>
                      <div id='bank-anchor' />
                      <Form.Item className='mb-0' name='bankSelect'>
                        <Select
                          id='bankSelect'
                          onChange={(value) => {
                            value !== -1 ? handleSelectPaymentMethod(value) : setBankModalOpen(true);
                          }}
                          defaultValue={selectedPaymentMethod.id}
                          value={selectedPaymentMethod.id}
                          menuItemSelectedIcon={<CheckCircle verticalAlign='-8px' />}
                          getPopupContainer={() => document.getElementById('bank-anchor')}
                          onDropdownVisibleChange={() => setBankOpen(!bankOpen)}
                          suffixIcon={bankOpen ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
                        >
                          {walletsData?.map((item) => (
                            <Select.Option value={item.id}>
                              {getBankLogo(item?.brandName)} {item?.brandName}{' '}
                              {item?.sourceType !== 'Wallet' && item?.sourceType !== 'add new' && `*** ${item?.lastFourDigit || ''}`}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </FloatingLabel>
                  ) : (
                    <div className='d-flex g-8 align-items-center'>
                      {getBankLogo(selectedPaymentMethod?.brandName || '')}
                      <span className='fz-16'>{selectedPaymentMethod?.brandName || ''}</span>
                      {selectedPaymentMethod?.sourceType !== 'Wallet' && (
                        <span className='text-taupe-80 fz-16'>{`*** ${selectedPaymentMethod?.lastFourDigit || ''}`}</span>
                      )}
                    </div>
                  )}
                </>
              )}

              <div className='d-flex mt-48'>
                <Checkbox checked={isTurmAndCondistion} onChange={(value) => setIsTurmAndCondistion(value.target.checked)} className='mr-16' />
                <span className='cursor-pointer fz-14'>
                  <span onClick={() => setIsTurmAndCondistion(!isTurmAndCondistion)}>I have read and accept the </span>
                  <Link to={{ pathname: '/legal', hash: 'Terms of use' }} className='underline' target='_blank'>
                    Terms of Use
                  </Link>
                  <span onClick={() => setIsTurmAndCondistion(!isTurmAndCondistion)}>, the </span>
                  <Link to={{ pathname: '/legal', hash: 'Other disclosure here' }} className='underline' target='_blank'>
                    Regulation A Investment Disclosure
                  </Link>
                  <span onClick={() => setIsTurmAndCondistion(!isTurmAndCondistion)}>, and </span>
                  <Link to={{ pathname: '/legal', hash: 'Privacy Policy' }} className='underline' target='_blank'>
                    Privacy Policy
                  </Link>
                  .
                </span>
              </div>
            </>
          )}
        </Modal>
      )}
      {screenMD && (
        <SuccessModal
          title={isSell === '2' ? SellSuccessData?.title : successData?.title || ''}
          description={
            isSell === '2'
              ? `You have successfully placed a sell order for ${numberOfShare || ''} shares ($${perSharePrice || ''} each) of ${
                  quickBuyPropertyData?.propertyName
                }. You will be notified through email about any progress made toward your sell order.
            `
              : `You have successfully requested to buy ${numberOfShare || ''} shares ($${perSharePrice || ''} each) of ${
                  quickBuyPropertyData?.propertyName
                }. You will be notified through email about any progress made toward your buy order.`
          }
          setOpen={props.open === 'success'}
          setClose={() => featchData()}
          setDone={() => {
            featchData();
          }}
        />
      )}
      {isTOSModal && <ListingAgreement isOpen={isTOSModal} onClose={onTOSModalClose} onAgreementAccept={onTOSAgreementSuccess} />}
    </>
  );
};

export default TradeModal;
